import { cn } from "../../../lib/utils";
import React from 'react';
import BreadcrumbItem from "./breadcrumbItem";
import { jsx as _jsx } from "react/jsx-runtime";
var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items,
    separator = _ref.separator,
    itemRender = _ref.itemRender,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/_jsx("div", {
    className: cn(className, 'flex', 'items-center', 'text-bds-font-size-14'),
    style: style,
    children: items.map(function (item, index) {
      var _item$label, _item$ellipsis;
      var label = itemRender ? itemRender(item, index, items) : (item === null || item === void 0 || (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.call(item)) || item.title;
      return BreadcrumbItem({
        separator: separator,
        children: label,
        key: item.key,
        ellipsis: (_item$ellipsis = item.ellipsis) !== null && _item$ellipsis !== void 0 ? _item$ellipsis : true,
        isLast: index === items.length - 1
      });
    })
  });
};
export default Breadcrumb;